import { render } from "./LessonProductDiscounts.vue?vue&type=template&id=4896aec0&scoped=true"
import script from "./LessonProductDiscounts.vue?vue&type=script&lang=js"
export * from "./LessonProductDiscounts.vue?vue&type=script&lang=js"

import "./LessonProductDiscounts.vue?vue&type=style&index=0&id=4896aec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4896aec0"]])

export default __exports__